/**
 * @generated SignedSource<<56d810160b1c8c6aec43277a7c486bbd>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ProductStatus = "PUBLISHED" | "UN_PUBLISHED";
export type productListProductsSetStatusMutation$variables = {
  productIDs: ReadonlyArray<string>;
  status: ProductStatus;
};
export type productListProductsSetStatusMutation$data = {
  readonly setStatusProducts: ReadonlyArray<{
    readonly id: string;
    readonly statusID: number;
  }> | null;
};
export type productListProductsSetStatusMutation = {
  response: productListProductsSetStatusMutation$data;
  variables: productListProductsSetStatusMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "productIDs"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "status"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "productIDs",
        "variableName": "productIDs"
      },
      {
        "kind": "Variable",
        "name": "status",
        "variableName": "status"
      }
    ],
    "concreteType": "Model",
    "kind": "LinkedField",
    "name": "setStatusProducts",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "statusID",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "productListProductsSetStatusMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "productListProductsSetStatusMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "7decc168cb50b24ee8ff8913a01e9c88",
    "id": null,
    "metadata": {},
    "name": "productListProductsSetStatusMutation",
    "operationKind": "mutation",
    "text": "mutation productListProductsSetStatusMutation(\n  $productIDs: [String!]!\n  $status: ProductStatus!\n) {\n  setStatusProducts(productIDs: $productIDs, status: $status) {\n    id\n    statusID\n  }\n}\n"
  }
};
})();

(node as any).hash = "bea558ae913a6b02bf235cb90e156e78";

export default node;
